var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGovbrLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 41,
    viewBox: "0 0 114 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 113.775,
    height: 41,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_662_279",
    transform: "scale(0.00900901 0.025)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_662_279",
    width: 111,
    height: 40,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAAAoCAMAAADHRlSGAAAAflBMVEVHcEz6vRAxd5IoZK8odpQnY676vRD5vRAoZK0oZK4oY65GrUQlZa8nZqonY64oY677vRAmY6//vxD6vRBErUP6vxD8vBAnZK5FrURFrUNFrEMnY676vRAoYq35vBD/vxBFqkZFrENErUT4vBBGrEOhtCnXuRooZK76vRBGrUSZ2+N1AAAAJ3RSTlMA1iBAEPDwwYDAoH8wcNDgf1AQZGcwRbDA2piQkGCwILDwOKNQnYto80LJAAAC+klEQVRYw+2X2ZqbMAxGzW4zEAIEyEYWMi3p+79gsS3JZpu5aXLRb3SFE1knkn8Jh7F/Y702zt5kP7wf3v/ESzzPS97F83mmvLN2WAi9E76qz85TWrSt5PJD2w53drg2PDeVEbI4Vw7lVpl8isLn05Gf5UGPtvFHvK2GaXNqxm5/tPnAg/WH4XEKJqRTpPeyQkeSvLa3LPMNr7Jp0i7FJ/AwwbteusSLrViBa3gQKhryD2xe3xCvCp9TcwoAHDUO8Hs6v3GsoVrAK5/Ea/pFY8UcNwCPmnDXvCNluxyEIy8knktfxmkam9/HHuASlnVRnxH4GwraKd6BTtOqohAZLfxociIsRTfVDe4GPSvEVVqnuDygQqS3Ka751fILDNqnhnepr+x6pXJC59BpYkYlKAPXvzTjID/b6edPixdrbwQK4mEcTAgVjgIDQYXYaVfY97A64mbOsp+EwZJGVMjxYNjgGrvDCAoMjjzak0Z8S6uYD3qfJrxqwiNHb8zbEg92RlDEG3VDtzTP+JgXsrX88m94jn/HKh7NSX7HM2XCQrPJ+a3WE5uug27Y2bxmpZ4mDIyTvoXRHYz14sz0gmU8djjLLF7AJjKc8TgNTrWkaYP6r8Fva3St8zrs8BxtfaZjFYgZL6G5kPssF/20351CueEwDQuaYlDOvBGp4QWeqhKmd5rxKPPp/EQlO0NGRRla+oGxomXDtdrMxjj3TjQW3TnPW+FdF+d1YY1NVU4o43KQhs15JKXxTjMyLYNhujM8cEdVi1GswF/iMfsdGTPTH/U0QwemhE+4A1QHVTd6mcpXwBKPediEWY7vJ9X/xcMmhqb38VoxzLKNjoy/MjFyCHK2whtUymPR8NzMF5hvRXnRSOdRWu7dHsxVb7AhMlXFT+HuxVWDnSNl59W7mpgMCtnqdfHV7c5NZndL/uXd0rWe23HfvuZuDHdFeRHF4icvvouLmPOTUbN4IW6p4b338k7srbzX/qtKssnQS9iLzW25EIG6qvLWfynqL/r5D/3pBzTJAAAAAElFTkSuQmCC"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovbrLogo);
export default __webpack_public_path__ + "static/media/govbr-logo.89e55e08380515648b60e234a92c8040.svg";
export { ForwardRef as ReactComponent };